import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import ls from 'localstorage-slim';

import DataContext from '../context/InvoiceData';

function Login() {
  let navigate = useNavigate();

  const { setIsAuthenticated } = useContext(DataContext);
  const [loginData, setLoginData] = useState({});

  const handleChange = event => {
    setLoginData({ ...loginData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    let url = '';
    const subDomain = loginData.email.split('@')[0];
    subDomain === 'admin' ? (url = `http://`) : (url = `http://${subDomain}.`);

    try {
      let response = await axios.post(
        `${url}${process.env.REACT_APP_DJANGO_BASEURL}/token/`,
        loginData
      );
      ls.clear();
      ls.set('subDomain', url);
      ls.set('access', response.data['access'], { ttl: 3600 });
      ls.set('refresh', response.data['refresh'], { ttl: 3600 * 24 });
      setIsAuthenticated(ls.get('access'));

      navigate('/taxpayer', { state: { showToast: true } });
    } catch (error) {
      if (error.response) {
        // Request made but the server responded with an error
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);

        toast.error(`${error.response.data}`, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      } else if (error.request) {
        // Request made but no response is received from the server.
        console.log(error.request);

        toast.error(`${error.request}`, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      } else {
        // Error occured while setting up the request
        console.log('Error', error.message);

        toast.error(`${error.message}`, {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      }
    }
  };

  return (
    <>
      <div className='container d-flex flex-column justify-content-center align-items-center'>
        <div className='row p-auto mt-5 mb-2'>
          <img
            src='/Sobol_logo.png'
            alt='Sobol Logo'
            className='mx-auto'
            style={{ width: '30%' }}
          />
        </div>
        <div className='row my-5'>
          <form onSubmit={handleSubmit}>
            <div className='row mb-3'>
              <label htmlFor='email' className='form-label'>
                Email
              </label>
              <input
                type='email'
                className='form-control'
                id='email'
                name='email'
                onChange={handleChange}
              />
            </div>
            <div className='row mb-3'>
              <label htmlFor='password' className='form-label'>
                Password
              </label>
              <input
                type='password'
                className='form-control'
                id='password'
                name='password'
                onChange={handleChange}
              />
            </div>
            <div className='row'>
              <button type='submit' className='btn btn-primary w-25 mx-auto'>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
